import { Flex, Icon, IconButton, ProductColor, Tooltip } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box
import { Box } from '@aloft/toolkit-sui/chakra';

import React from 'react';

import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch } from '../../../redux/hooks.ts';
import { PropertyPinStatus } from '../../Tkv2Map/types.ts';

type ValuationTablePropertyHeaderPinProps = {
  hideActions: boolean;
  pinColor: ProductColor;
  pinStatus: PropertyPinStatus;
};

export const ValuationTablePropertyHeaderPin = ({
  hideActions,
  pinColor,
  pinStatus,
}: ValuationTablePropertyHeaderPinProps) => {
  const dispatch = useAppDispatch();

  const handleMapPinClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    // Setting the active id is already handled by the useTkv2ReferenceBarEvents hook
    dispatch(setSelectedDataSheet('mls-map'));
    dispatch(setReferenceViewOpen(true));
  };

  const statusLetter = pinStatus.charAt(0).toUpperCase();

  return (
    <Tooltip openDelay={500} label={`${pinStatus}: View on map`} isDisabled={hideActions}>
      <Flex alignItems="center" justifyContent="center" position="relative">
        {hideActions ? (
          <Icon icon="map-pin-filled" size="md" color={pinColor} />
        ) : (
          <IconButton
            icon="map-pin-filled"
            iconSize="lg"
            iconColor={pinColor}
            ariaLabel={pinStatus}
            variant="tertiary"
            size="md"
            __dangerDoNotUseSx={{
              padding: '0px',
              width: 'fit-content',
              height: 'fit-content',
            }}
            onClick={handleMapPinClick}
          />
        )}
        <Box
          position="absolute"
          top={hideActions ? '40%' : '50%'}
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize={hideActions ? '0.5rem' : '0.75rem'}
          fontWeight="bold"
          color="white"
          lineHeight="1"
          pointerEvents="none"
          userSelect="none"
        >
          {statusLetter}
        </Box>
      </Flex>
    </Tooltip>
  );
};
